import store from '@/store';
import { MESSAGE_TYPE } from '@/constants/message';
import locales from '@/modules/locales/dict'
import localeLinks from '@/modules/locales/links';

/**
 * Обработка ошибок
 * @param error {Error}
 * @param fallbackErrorText {String} текст ошибки по умолчанию, если она отсутствует в ответе сервера
 */
export const errorHandler = (error, fallbackErrorText = '') => {
    const messages = [];

    if (error.response?.data?.errors) {
        error.response.data.errors.forEach((error) => {
            const errorMessage = error?.detail || error?.title
            if (errorMessage) messages.push(errorMessage)
        });
    }

    if (messages.length) {
        // fallback is shown; alert is redundant
        if (error.response?.data?.errors?.[0]?.status === 401) return;

        store.commit('message/show', {
            text: messages.join('<br>'),
            type: MESSAGE_TYPE.ERROR
        });
        return;
    }

    const lang = store.state.queryParams.lang
    const errors = locales[lang].errors
    const zendeskLink = localeLinks[lang].zendesk
    const tryAgainText = `${errors.tryAgain.text} <a href="${zendeskLink}" target="_blank">${errors.tryAgain.tos}</a>.`
    const defaultErrorText = `${errors.internal}<br>${tryAgainText}`

    store.commit('message/show', {
        text: fallbackErrorText || defaultErrorText,
        type: MESSAGE_TYPE.ERROR
    });
}
